import { gql } from "@apollo/client"

export const ALL_TAX_PROVIDERS = gql`
  query getTaxProviders {
    getTaxProviders {
      id
      type
    }
  }
`
